import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet } from './';
import { ConnectorModel } from './connector.model';
import VertexAIIcon from '@/assets/connector-icons/vertex-ai.svg';

export type VertexAIConfig = {
  serviceAccountJson: string;
};

export class VertexAIConnectorModel extends ConnectorModel {
  config: VertexAIConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'vertex-ai';
    this.typeLabel = 'Google Vertex AI';
    this.iconSVG = VertexAIIcon;

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: true,
      contextData: false,
      ingress: false,
    };

    this.config = (data.config as VertexAIConfig) || {
      serviceAccountJson: '',
    };

    this.canListProviderModels = true;
  }
}
